exports = module.exports = require("../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".grid-container{margin-left:-24px;margin-right:-24px;margin-top:16px}", ""]);

